import dataAuth from '@/components/data-auth';
export default {
  data: function data() {
    return {
      dataAuthType: 2 // 数据权限类型(1:通知公告,2:公文流转)
    };
  },
  components: {
    dataAuth: dataAuth
  }
};